import request from '@/utils/request'
import { resetRouter } from '@/router'
import { setToken, removeToken, setUserData, removeUserData } from '@/utils/auth'

export default {
  async login({ commit }, payload) {
    const { username, password } = payload
    return request
      .post('/api/auth/login', { username: username, password: password, isAdmin: true })
      .then(({ data }) => {
        const { accessToken, user } = data
        commit('SET_TOKEN', accessToken)
        commit('SET_USER_DATA', user)
        setUserData(user)
        setToken(accessToken)
        resetRouter()
        return data
      })
  },

  async changePassword({ commit }, payload) {
    return request.put('/api/auth/update-password', payload)
  },

  async getProfile({ commit, dispatch }) {
    return request
      .get('/api/auth/profile')
      .then(({ data }) => {
        const { user } = data
        commit('SET_USER_DATA', user)
        setUserData(user)
      })
      .catch(() => {
        dispatch('logout')
      })
  },

  // user logout
  async logout({ commit }) {
    removeToken() // must remove  token  first
    removeUserData()
    commit('SET_TOKEN', null)
    commit('SET_USER_DATA', {})
    resetRouter()
  },

  // remove token
  async resetToken({ commit }) {
    removeToken() // must remove  token  first
    commit('SET_TOKEN', null)
    commit('SET_USER_DATA', {})
  },
}
